import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PrismGridRow from './PrismGridRow';

import { COLUMN_PROP_TYPES } from '../constants';

class PrismGridBody extends React.Component {
    static propTypes = {
        data: PropTypes.arrayOf(PropTypes.object),
        columns: PropTypes.arrayOf(COLUMN_PROP_TYPES).isRequired,
        className: PropTypes.string,
        rowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
        selection: PropTypes.arrayOf(PropTypes.object),
        onChangeSelection: PropTypes.func
    };

    static defaultProps = {
        data: [],
        rowClassName: '',
        onRowSelect: [],
        onChangeSelection: () => { }
    };

    renderRows = ({
        data,
        columns,
        rowClassName,
        selection,
        onChangeSelection
    }) => (
        <>
            {data.map((rowData, index) => {
                const selected = selection.findIndex((item) => item.id === rowData.id) > -1;

                return (
                    <React.Fragment key={`row_${index}`}>
                        <PrismGridRow
                            index={index}
                            columns={columns}
                            data={rowData}
                            selected={selected}
                            className={rowClassName}
                            onChangeSelection={onChangeSelection}
                        />
                    </React.Fragment>
                );
            })}
        </>
    )

    render() {
        const containerClassName = classNames(
            'prism-grid__body',
            this.props.className
        );

        return (
            <div className={containerClassName}>
                {this.renderRows(this.props)}
            </div>
        )
    }
}

export default PrismGridBody;
